//  /helpers/g_funcs.js  系统公共函数

 /*
  * 验证用户名有效性
  */
function checkName(username){
  var voter = {errno : 0, error : ''};
  if (String(username).length < 6 || String(username).length > 16) {
    voter.errno = 1;
    voter.error = '用户名长度6-16位';
  }
  return voter;
}


/*
 * 验证密码
 */

function checkChilper(password){
  var voter = {errno : 0, error : ''};
  if (String(password).length < 8) {
    voter.errno = 1;
    voter.error = '密码长度至少8位';
  }
  return voter;
}

/*
 * 构建格式化时间
 */

function formatDate(timstamp, fmt){
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}


export default {
  checkName,
  checkChilper,
  formatDate
};








//////////////////
// WEBPACK FOOTER
// ./helpers/g_funcs.js
// module id = o3xn
// module chunks = 0